import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Content } from 'src/contexts/ContentContext';
import {
  NO_GROUP_ID,
  useMultiSelectionContext,
} from 'src/contexts/MultiSelectionContext';
import { Button } from 'src/core/ui';
import { useCatchUpModeEventIdsMap } from 'src/hooks/api/useCacheUpModeEventIdsMap';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import {
  ACTIVE_EVENT_IDS_2_QUERY_PARAM,
  TAB_EVENT_IDS_MAPPING_ID,
} from 'src/navigations/Routes/InventoryEvent/InventoryEvent.constants';
import { DemandDashboardIsOnSaleEventQueryParam } from 'src/utils/constants/constants';
import { ContentId } from 'src/utils/constants/contentId';
import { CatchUpModeSource, Feature } from 'src/WebApiController';

export const OnSaleEventCatchUpAction = () => {
  const hasEventDiscoveryInInventoryViewFeature = useUserHasFeature(
    Feature.EventDiscoveryInInventoryView
  );
  const navigate = useNavigate();
  const { itemSelection } = useMultiSelectionContext();

  const { onSaveCatchUpModeEventIds, isLoading } = useCatchUpModeEventIdsMap();

  const selectedEventIds = useMemo(() => {
    return itemSelection[NO_GROUP_ID]?.items ?? [];
  }, [itemSelection]);

  const urlPrefix = useMemo(() => {
    if (hasEventDiscoveryInInventoryViewFeature) {
      return '/inventory/event';
    }
    return '/discovery/event';
  }, [hasEventDiscoveryInInventoryViewFeature]);

  const onCatchUp = useCallback(async () => {
    const cacheId = await onSaveCatchUpModeEventIds(
      CatchUpModeSource.OnSaleEvents,
      selectedEventIds
    );

    // TODO: this is the place where we want to carry over the custom filters in the URL state
    const activeEventId = selectedEventIds?.[0];
    let catchUpEventUrl = `${urlPrefix}?${ACTIVE_EVENT_IDS_2_QUERY_PARAM}=${activeEventId}&${TAB_EVENT_IDS_MAPPING_ID}=${cacheId}`;
    if (hasEventDiscoveryInInventoryViewFeature) {
      catchUpEventUrl += `&${DemandDashboardIsOnSaleEventQueryParam}=true`;
    }
    navigate(catchUpEventUrl);
  }, [
    hasEventDiscoveryInInventoryViewFeature,
    navigate,
    onSaveCatchUpModeEventIds,
    selectedEventIds,
    urlPrefix,
  ]);

  const disabled = useMemo(() => {
    if (!selectedEventIds?.length) {
      return true;
    }

    return isLoading;
  }, [isLoading, selectedEventIds?.length]);

  return (
    <Button variant="outline" onClick={onCatchUp} disabled={disabled}>
      <Content id={ContentId.Catchup} />
    </Button>
  );
};
